module.exports = __webpack_public_path__ + "img/error.8895dc27.svg";